import { useDispatch } from "react-redux";
import { regexHaveLowerCase, regexHaveNumber, regexHaveUppercase } from "@/utils/functions";
import PasswordView from "./view";
import { useNavigate } from "react-router-dom";
import { changePasswordAuth, setCustomer } from "@/redux/ducks/customer";
import { useEffect, useRef, useState } from "react";

export default function Password() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [isVisiblePassword, setIsVisiblePassword] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [isVisibleNewPassword, setIsVisibleNewPassword] = useState(false);
  const refPassword = useRef<HTMLInputElement | null>(null);
  const refNewPassword = useRef<HTMLInputElement | null>(null);

  const goBack = () => navigate(-1);

  const toggleIsVisiblePassword = () => setIsVisiblePassword(isVisiblePassword => !isVisiblePassword);
  const toggleIsVisibleNewPassword = () => setIsVisibleNewPassword(isVisibleNewPassword => !isVisibleNewPassword);


  const itemsConfirm = [
    {
      text: 'Ter no Mínimo 8 Caracteres e no Máximo 20 Caracteres',
      success: newPassword?.length >= 8 && newPassword?.length <= 20,
    },
    {
      text: 'Pelo Menos 1 Letra Maiúscula',
      success: regexHaveUppercase.test(newPassword),
    },
    {
      text: 'Pelo Menos 1 Letra Minúscula',
      success: regexHaveLowerCase.test(newPassword),
    },
    {
      text: 'Pelo Menos 1 Número',
      success: regexHaveNumber.test(newPassword),
    },
    {
      text: 'Diferente da senha atual',
      success: password !== newPassword,
    },
  ];

  const [validatesNewPassword, setValidatesNewPassword] = useState(itemsConfirm);

  const onInput = () => {
    setPassword(refPassword.current?.value ?? "");
    setNewPassword(refNewPassword.current?.value ?? "");
  }

  const getIsDisabled = () => {
    if (validatesNewPassword?.some(item => !item.success)) return true;
    return false;
  }

  const goToLogin = () => {
    setSuccess(false);
    dispatch(
      setCustomer({
        accessToken: undefined,
        refreshToken: undefined,
        register: undefined, 
        forgot: undefined,
        customer: undefined,
        products: undefined,
        vehicles: undefined,
        extract: undefined,
        recharges: undefined,
        pinDevice: undefined,
        isLoadingVehicles: false,
        selectedVehicles: undefined,
      })
    );
  }

  const handleChangePassword = (success: boolean, errorMessage?: string) => {
    setIsLoading(false);

    if (!success) {
      setError(true);
      return;
    }

    setSuccess(true);
  };

  const submit = (e?: React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault();

    if (getIsDisabled() || isLoading) return;

    setIsLoading(true);
    setError(false);

    dispatch(
      changePasswordAuth({
        password: password,
        newPassword: newPassword,
        callback: handleChangePassword,
      })
    );
  }

  useEffect(() => {
    setValidatesNewPassword(itemsConfirm);
  }, [newPassword]);

  return <PasswordView
    goBack={goBack}
    submit={submit}
    isDisabled={getIsDisabled()}
    validatesNewPassword={validatesNewPassword}
    isVisiblePassword={isVisiblePassword}
    isVisibleNewPassword={isVisibleNewPassword}
    toggleIsVisiblePassword={toggleIsVisiblePassword}
    toggleIsVisibleNewPassword={toggleIsVisibleNewPassword}
    error={error}
    setError={setError}
    isLoading={isLoading}
    goToLogin={goToLogin}
    success={success}
    refPassword={refPassword}
    refNewPassword={refNewPassword}
    onInput={onInput}
  />
}
